import { t } from "../../i18n";
import { useState } from "react";
import type { FontFamily } from "../../storage";
import {
  FONT_FAMILIES,
  TEXT_SIZE_PERCENT_OPTIONS,
  applyFontFamily,
  applyTextPrefs,
  loadFontFamily,
  loadTextBold,
  loadTextSizePercent,
  saveFontFamily,
  saveTextBold,
  saveTextSizePercent
} from "../../storage";

type Props = {
  back: React.ReactNode;
};

const SIZE_LABELS = ["Κανονικό", "Μεγάλο", "Πολύ μεγάλο", "Τεράστιο"];

export function TextPage({ back }: Props) {
  const [percent, setPercent] = useState(loadTextSizePercent);
  const [bold, setBold] = useState(loadTextBold);
  const [family, setFamily] = useState<FontFamily>(loadFontFamily);

  const changeFamily = (next: FontFamily): void => {
    setFamily(next);
    saveFontFamily(next);
    applyFontFamily(next);
  };

  const changeSize = (next: number): void => {
    setPercent(next);
    saveTextSizePercent(next);
    applyTextPrefs(next, bold);
  };

  const changeBold = (next: boolean): void => {
    setBold(next);
    saveTextBold(next);
    applyTextPrefs(percent, next);
  };

  return (
    <section className="screen settings-screen" aria-labelledby="settings-heading">
      {back}
      <div className="screen-heading-row">
        <div>
          <h1 id="settings-heading">{t("Κείμενο")}</h1>
          <p>{t("Γραμματοσειρά, μέγεθος και πάχος")}</p>
        </div>
      </div>

      <div className="settings-groups">
        <section className="settings-group">
          <h2>{t("Γραμματοσειρά")}</h2>
          <label className="field">
            <select
              value={family}
              onChange={(event) => changeFamily(event.target.value as FontFamily)}
              aria-label={t("Γραμματοσειρά")}
            >
              {FONT_FAMILIES.map((font) => (
                <option value={font.value} key={font.value}>
                  {t(font.label)}
                </option>
              ))}
            </select>
          </label>
        </section>

        <section className="settings-group">
          <h2>{t("Μέγεθος κειμένου")}</h2>
          <label className="field">
            <select
              value={percent}
              onChange={(event) => changeSize(Number(event.target.value))}
              aria-label={t("Μέγεθος κειμένου")}
            >
              {TEXT_SIZE_PERCENT_OPTIONS.map((option, index) => (
                <option value={option} key={option}>
                  {t(SIZE_LABELS[index])}
                </option>
              ))}
            </select>
          </label>
        </section>

        <section className="settings-group">
          <h2>{t("Πάχος γραμμάτων")}</h2>
          <label className="field">
            <select
              value={bold ? "1" : "0"}
              onChange={(event) => changeBold(event.target.value === "1")}
              aria-label={t("Πάχος γραμμάτων")}
            >
              <option value="0">{t("Κανονικά")}</option>
              <option value="1">{t("Έντονα")}</option>
            </select>
          </label>
        </section>

        <section className="settings-group">
          <h2>{t("Προεπισκόπηση")}</h2>
          <p className="hint-text">{t("2x ΠΑΤΑΤΕΣ ΤΗΓΑΝΗΤΕΣ • χωρίς αλάτι")}</p>
        </section>
      </div>
    </section>
  );
}
